/** Decode JWT `exp` (seconds since epoch) without a third-party library. */
export function decodeJwtExp(token: string): number | null {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;

    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");
    const json = JSON.parse(atob(padded)) as { exp?: unknown };

    return typeof json.exp === "number" ? json.exp : null;
  } catch {
    return null;
  }
}

export function isJwtExpired(exp: number | null | undefined, skewSeconds = 30): boolean {
  if (!exp) return true;
  const now = Math.floor(Date.now() / 1000);
  return now >= exp - skewSeconds;
}
